import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=5936f75e&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=ts&"
export * from "./Header.vue?vue&type=script&lang=ts&"
import style0 from "../style.scss?vue&type=style&index=0&id=5936f75e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5936f75e",
  null
  
)

export default component.exports